import type { CardViewModel } from '@pesto/features/src/Cards/types/Cards.types';

import { toCardViewModel } from '@pesto/features/src/Cards/utils/toCardViewModel';

import type { GetCardByIdQuery } from '../../__generated__/graphql/api';

type GeneratedCard = NonNullable<NonNullable<NonNullable<GetCardByIdQuery['listCards']>['cards']>[number]>;

type GeneratedCardUser = NonNullable<GeneratedCard['user']>;

export interface CardOwnerLink {
  id: string;
  displayName: string | null;
  isFriendsAndFam: boolean | null;
}

export interface CardLoanLink {
  id: string;
  partnerAccountNumber: string | null;
}

export interface CardDetailViewModel extends CardViewModel {
  owner: CardOwnerLink | null;
  loan: CardLoanLink | null;
}

const buildOwnerDisplayName = (user: GeneratedCardUser): string | null => {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();

  return name === '' ? null : name;
};

const toOwner = (user: GeneratedCard['user']): CardOwnerLink | null => {
  if (!user || !user.id) return null;

  return {
    id: user.id,
    displayName: buildOwnerDisplayName(user),
    isFriendsAndFam: user.isFriendsAndFam ?? null,
  };
};

const toLoan = (loan: GeneratedCard['loan']): CardLoanLink | null => {
  if (!loan?.id) return null;

  return {
    id: loan.id,
    partnerAccountNumber: loan.partnerAccountNumber ?? null,
  };
};

export const toCardDetail = (card: GeneratedCard): CardDetailViewModel => ({
  ...toCardViewModel(card),
  owner: toOwner(card.user),
  loan: toLoan(card.loan),
});
